<template>
  <InputPopover
    ref="popover"
    v-bind="{ modelValue, icon, borderless, outlined, dense, error, errorMessage, label, placeholder, useInput, clearable, autofocus, separator, multiple, disable, hideSelected, display, valueDebounce, showSelection, hideOnFirstClick, inputClass }"
    :search="search"
    :loading="loading"
    :results="results"
    :placeholder="placeholder"
    friendly-name="user"
    option-label="name"
    separator
    @blur="onBlur"
    @clear="onClear"
    @update:model-value="onInput"
    @clicked-result="onClickedResult"
    @removed-result="onRemovedResult"
  >
    <template #advanced>
      <slot name="advanced" />
    </template>
    <template #option="scope">
      <user-item
        v-bind="scope.itemProps"
        :user="scope.opt"
        dense
        without-email
      >
        <template v-if="showSelection" #default>
          <component
            :is="multiple ? 'q-checkbox' : 'q-radio'"
            :model-value="scope.selected"
            :val="true"
            dense
            class="no-pointer-events"
          />
        </template>
      </user-item>
    </template>
    <template
      #selected-chip="scope"
    >
      <user-chip
        dense
        removable
        without-btns
        :user="scope.opt"
        @remove="removeModelAtIndex(scope.index)"
      />
    </template>
    <template #selected-item="scope">
      <user-item
        :user="scope.item"
        :disable="disable"
        dense
      >
        <cancel-button
          @click="removeModelAtIndex(scope.index)"
        />
      </user-item>
    </template>
  </InputPopover>
</template>

<script>
import InputPopover from 'components/partials/search/inputPopover/InputPopover'
import inputPopoverMixin from 'components/partials/search/inputPopover/inputPopoverMixin'

import searchMixin from './mixins/searchMixin'

export default {
  components: {
    InputPopover
  },
  mixins: [searchMixin, inputPopoverMixin],
  methods: {
    search (val, update, abort) {
      this.doSearch(val, () => {
        update()
      }, () => {
        abort()
      })
    }
  }
}
</script>
